import { useEffect, useState } from "react";

import {
  TableMetadata,
  useTable,
  MultiTypeDownloadToolTip,
} from "@king-ict/eupisi-ui/components";
import { ExportTypeEnum } from "@king-ict/eupisi-ui/models";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";

import {
  getImportantDatePedagogicalYears,
  getPedagogicalYearExportFile,
} from "../../../api";
import { editImportantDateUrl } from "../../../app";
import {
  AdministrationList,
  AdministrationListFiltersData,
  AdministrationListHeader,
} from "../../../components";
import { PedagogicalYear } from "../../../models";
import styles from "./RegularImportantDateList.module.scss";

export const RegularImportantDateList = () => {
  const [pedagogicalYears, setpedagogicalYears] = useState<PedagogicalYear[]>(
    []
  );

  const [exportType, setExportType] = useState<number>(ExportTypeEnum.Excel);

  const { t } = useTranslation();
  const history = useHistory();

  useEffect(() => {
    (async () => {
      setpedagogicalYears(await getImportantDatePedagogicalYears());
    })();
  }, []);

  const handleDetailsClicked = (id?: number, guid?: string) => {
    if (id) {
      history.push(editImportantDateUrl(id!));
    }
  };

  const handleChangeFormat = (typeId: number) => {
    setExportType(typeId);
  };

  const handleDownloadDocument = () => {
    getPedagogicalYearExportFile(exportType);
  };

  const [tableProps] = useTable<AdministrationListFiltersData>({
    data: pedagogicalYears,
    totalItems: pedagogicalYears.length,
    noHover: true,

    metadata: {
      rowKey: "id",
      columns: [
        {
          columnKey: "pedagogicalYearName",
          header: t("common.pedagogicalYear"),
          accessor: "name",
        },
      ],
    } as TableMetadata<PedagogicalYear>,
  });

  return (
    <>
      <AdministrationListHeader
        infoMessage={t("importantDates.infoMessage")}
        title={t("importantDates.listTitle")}
      />
      <AdministrationList
        tableProps={tableProps}
        isCreateEnabled={false}
        isDeleteEnabled={false}
        isDetailsEnabled={true}
        onDetailsClicked={handleDetailsClicked}
      />
      {pedagogicalYears?.length > 0 && (
        <MultiTypeDownloadToolTip
          exportType={exportType}
          onclick={handleDownloadDocument}
          changeFormat={handleChangeFormat}
        />
      )}
    </>
  );
};
